(() => {
  'use strict';
  const cleanups = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('[data-reveal]').forEach(element => {
      if (element.dataset.revealReady || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      element.dataset.revealReady = 'true';
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('reveal', 'fc-reveal-ready');
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) { element.classList.add('in'); observer.disconnect(); }
      }, {threshold:.06, rootMargin:'0px 0px -6% 0px'});
      observer.observe(element); cleanups.set(element, () => observer.disconnect());
    });
    root.querySelectorAll('[data-header]').forEach(header => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const menu = header.querySelector('[data-menu]');
      const opener = header.querySelector('[data-open-menu]');
      const updateHeight = () => document.documentElement.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
      const observer = new ResizeObserver(updateHeight); observer.observe(header); updateHeight();
      const close = () => { if (menu.open) menu.close(); };
      opener?.addEventListener('click', () => { menu.showModal(); opener.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; });
      menu?.addEventListener('click', e => { if (e.target.closest('[data-close-menu], a') || e.target === menu) close(); });
      menu?.addEventListener('close', () => { document.body.style.overflow = ''; opener?.setAttribute('aria-expanded', 'false'); opener?.focus(); });
      cleanups.set(header, () => { observer.disconnect(); close(); });
    });
    root.querySelectorAll('[data-therapist-discovery]').forEach(discovery => {
      if (discovery.dataset.ready) return; discovery.dataset.ready = 'true';
      const chips = [...discovery.querySelectorAll('[data-concern]')];
      const cards = [...discovery.querySelectorAll('[data-therapist-card]')];
      const status = discovery.querySelector('[data-match-status]');
      const empty = discovery.querySelector('[data-match-empty]');
      const apply = () => {
        const selected = chips.filter(c => c.getAttribute('aria-pressed') === 'true').map(c => c.dataset.concern);
        let count = 0;
        cards.forEach(card => {
          const tags = card.dataset.concerns.trim().split(/\s+/);
          const match = !selected.length || selected.some(t => tags.includes(t));
          card.hidden = !match;
          card.classList.toggle('matched', !!selected.length && match);
          count += match ? 1 : 0;
        });
        if (status) status.textContent = selected.length ? (count ? 'Profiles that work with your selected concerns are shown below.' : 'No profile matches that selection here yet.') : 'Explore our therapists below.';
        if (empty) empty.hidden = count > 0;
      };
      chips.forEach(chip => chip.addEventListener('click', () => { chip.setAttribute('aria-pressed', String(chip.getAttribute('aria-pressed') !== 'true')); apply(); }));
      discovery.querySelector('[data-concern-clear]')?.addEventListener('click', () => { chips.forEach(c => c.setAttribute('aria-pressed', 'false')); apply(); });
    });
    const rail = document.querySelector('[data-home-rail]');
    const anchor = document.querySelector('[data-rail-after]');
    if (rail && !rail.dataset.ready && anchor) {
      rail.dataset.ready = 'true';
      const io = new IntersectionObserver(entries => {
        const show = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
        rail.classList.toggle('show', show); rail.inert = !show;
      });
      rail.inert = true; io.observe(anchor); cleanups.set(rail, () => io.disconnect());
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-header],[data-home-rail],[data-reveal]').forEach(el => { cleanups.get(el)?.(); cleanups.delete(el); });
  });
})();
